import Icon from "./Icon";

/* A clickable banner card: image/gradient banner + title.
   Clicking anywhere on the banner (or title) opens the detail view. */
export default function BannerCard({ item, index, onOpen }) {
  return (
    <button
      onClick={() => onOpen(item)}
      className="group relative flex h-full flex-col overflow-hidden rounded-3xl bg-cream text-left shadow-[0_18px_40px_-24px_rgba(34,21,16,0.45)] ring-1 ring-ink/5 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-28px_rgba(218,33,40,0.45)]"
    >
      {/* Banner */}
      <div className="relative h-44 overflow-hidden">
        <div
          className={`absolute inset-0 bg-gradient-to-br ${item.accent} transition-transform duration-500 group-hover:scale-105`}
        />
        {/* Decorative pattern */}
        <div
          className="absolute inset-0 opacity-25"
          style={{
            backgroundImage:
              "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.7) 1px, transparent 0)",
            backgroundSize: "18px 18px",
          }}
        />
        <div className="absolute -right-6 -top-6 h-28 w-28 rounded-full bg-cream/15 blur-xl" />
        <div className="absolute -bottom-10 -left-6 h-32 w-32 rounded-full bg-ink/20 blur-2xl" />

        {/* Index + icon */}
        <div className="absolute left-4 top-4 flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-cream/90 text-deeprose shadow-sm">
            <Icon name={item.icon} className="h-5 w-5" />
          </span>
          <span className="rounded-full bg-ink/25 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-cream backdrop-blur-sm">
            {String(index + 1).padStart(2, "0")}
          </span>
        </div>

        {/* Category tag */}
        <span className="absolute right-4 top-4 rounded-full bg-cream/90 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-deeprose">
          {item.category}
        </span>

        {/* Hover CTA */}
        <div className="absolute bottom-3 right-4 flex translate-y-2 items-center gap-1.5 rounded-full bg-cream px-3 py-1.5 text-xs font-bold text-deeprose opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          Read & Download
          <Icon name="arrow" className="h-3.5 w-3.5" />
        </div>
      </div>

      {/* Body */}
      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-display text-lg font-bold leading-snug text-ink transition-colors group-hover:text-brand">
          {item.title}
        </h3>
        <p className="mt-1.5 text-sm leading-relaxed text-mute">
          {item.subtitle}
        </p>

        <div className="mt-auto flex items-center justify-between pt-4">
          <div className="flex items-center gap-1.5 text-xs font-medium text-mute">
            <Icon name="calendar" className="h-3.5 w-3.5" />
            {item.date}
          </div>
          <div className="flex items-center gap-1.5 text-xs font-semibold text-ink/60">
            <Icon name="doc" className="h-3.5 w-3.5" />
            {item.format} · {item.pages}p
          </div>
        </div>
      </div>
    </button>
  );
}
